import { ResumeHeader } from '../../types';
import { Plus, X } from 'lucide-react';

interface HeaderSectionProps {
    header: ResumeHeader;
    onChange: (header: ResumeHeader) => void;
}

export function HeaderSection({ header, onChange }: HeaderSectionProps) {
    const addLink = () => {
        onChange({
            ...header,
            links: [...header.links, { label: '', url: '' }],
        });
    };

    const removeLink = (index: number) => {
        onChange({
            ...header,
            links: header.links.filter((_, i) => i !== index),
        });
    };

    const updateLink = (index: number, field: 'label' | 'url', value: string) => {
        const newLinks = [...header.links];
        newLinks[index] = { ...newLinks[index], [field]: value };
        onChange({ ...header, links: newLinks });
    };

    return (
        <div className="card">
            <h2 className="section-title">Contact Information</h2>

            <div className="space-y-4">
                <div>
                    <label className="label">Full Name *</label>
                    <input
                        type="text"
                        value={header.fullName}
                        onChange={(e) => onChange({ ...header, fullName: e.target.value })}
                        className="input"
                        placeholder="John Doe"
                    />
                </div>

                <div>
                    <label className="label">Email *</label>
                    <input
                        type="email"
                        value={header.email}
                        onChange={(e) => onChange({ ...header, email: e.target.value })}
                        className="input"
                        placeholder="john@example.com"
                    />
                </div>

                <div>
                    <label className="label">Phone</label>
                    <input
                        type="tel"
                        value={header.phone || ''}
                        onChange={(e) => onChange({ ...header, phone: e.target.value })}
                        className="input"
                        placeholder="+1 (555) 123-4567"
                    />
                </div>

                <div>
                    <label className="label">Location</label>
                    <input
                        type="text"
                        value={header.location || ''}
                        onChange={(e) => onChange({ ...header, location: e.target.value })}
                        className="input"
                        placeholder="San Francisco, CA"
                    />
                </div>

                <div>
                    <div className="flex justify-between items-center mb-2">
                        <label className="label mb-0">Links</label>
                        <button onClick={addLink} className="btn btn-secondary text-sm flex items-center gap-1">
                            <Plus size={16} />
                            Add Link
                        </button>
                    </div>

                    {header.links.map((link, index) => (
                        <div key={index} className="flex gap-2 mb-2">
                            <input
                                type="text"
                                value={link.label}
                                onChange={(e) => updateLink(index, 'label', e.target.value)}
                                className="input flex-1"
                                placeholder="LinkedIn"
                            />
                            <input
                                type="url"
                                value={link.url}
                                onChange={(e) => updateLink(index, 'url', e.target.value)}
                                className="input flex-1"
                                placeholder="https://linkedin.com/in/johndoe"
                            />
                            <button
                                onClick={() => removeLink(index)}
                                className="text-red-600 hover:text-red-700 p-2"
                            >
                                <X size={20} />
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
